import get from "lodash/get";
import {FieldErrors} from "react-hook-form";

// I don't think this is perfect. I would want to improve it to handle our weird django error structure as well.
// Also handle an array of errors and allow the SubFormText to take an array of errors
export const getFormError = (fieldName: string, RHFErrors: FieldErrors) => {
  const errorsObject = get(RHFErrors, fieldName);
  if (errorsObject && typeof errorsObject === "object" && !Array.isArray(errorsObject)) {
    return errorsObject?.message ?? errorsObject?.root?.message;
  } else if (Array.isArray(errorsObject) && errorsObject.length > 0) {
    return errorsObject[0]?.message;
  }
  return undefined;
};
